'use client';
import loadBackgroudImages from '../../common/loadBackgroudImages';
import React, { useEffect } from 'react';

function Feat() {
  useEffect(() => {
    loadBackgroudImages();
  }, []);
  return (
    <section id="nosotros" className="feat section-padding">
      <style jsx>{`
        #nosotros {
          padding-bottom: 60px !important;
        }
        @media screen and (max-width: 768px) {
          #nosotros {
            padding-bottom: 40px !important;
          }
          #nosotros p {
            text-align: justify !important;
          }
        }
      `}</style>
      <div className="container ontop">
        <div className="row">
          <div className="col-lg-5">
            <div className="cont md-mb30">
              <h6 className="sub-title main-color mb-15">Cítricos Naturales</h6>
              <h3 className="mb-20">
                Nosotros
              </h3>
              <p className="mb-20">
                En Cítricos Naturales nos aseguramos de que cada jugo no solo refresque, sino que también ofrezca la máxima potencia y riqueza del poder de los cítricos recién cosechados.

                Gracias al extracto de fruta fresca, podemos ofrecerte un sabor que transporta directamente al origen y que captura la vitalidad pura de la naturaleza.
              </p>
              <p className="mb-20">
                Somos una compañía cuya misión es elaborar y comercializar zumos y jugos naturales. Nuestros productos están enfocados a un mercado objetivo específico y están listos para el consumo directo y procesos complementarios.
              </p>
            </div>
          </div>
          <div className="col-lg-6 offset-lg-1">
            <div className="item mb-20">
              <div className="row">
                <div
                  className="col-md-4 bg-img"
                  data-background="/assets/imgs/productos/aboutus/3.jpg"
                ></div>
                <div className="col-md-8">
                  <div className="info">
                    <h5 className="mb-15">Misión y Visión</h5>
                    <p>
                      Basamos nuestro crecimiento en un abastecimiento de fruta fresca, sostenible y de alta calidad, para garantizar la excelencia de nuestros productos e impulsar el bienestar de nuestros clientes                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="item mb-20">
              <div className="row">
                <div
                  className="col-md-4 bg-img"
                  data-background="/assets/imgs/productos/aboutus/2.jpg"
                ></div>
                <div className="col-md-8">
                  <div className="info">
                    <h5 className="mb-15">¿Por qué elegirnos?</h5>
                    <p>
                      Llevamos la inocuidad y la excelencia como pilares de nuestro producto, contamos con +6 años de experiencia y +150 puntos abastecidos.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="item mb-20">
              <div className="row">
                <div
                  className="col-md-4 bg-img"
                  data-background="/assets/imgs/productos/aboutus/1.jpg"
                ></div>
                <div className="col-md-8">
                  <div className="info">
                    <h5 className="mb-15">¿A quien nos dirigimos?</h5>
                    <p>
                      Nuestro público objetivo incluye hoteles, restaurantes, cafeterías, bares y clubes sociales, entre otros. Nos enfocamos en todos aquellos establecimientos que priorizan el bienestar y la calidad para sus consumidores.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="item">
              <div className="row">
                <div
                  className="col-md-4 bg-img"
                  data-background="/assets/imgs/productos/aboutus/1.jpg"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="circle-blur">
        <img src="/assets/imgs/patterns/blur1.png" alt="" />
      </div>
    </section>
  );
}

export default Feat;
